import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import _ from 'underscore';

import { FavoriteToggle } from '~common/react/components/FavoriteToggle/FavoriteToggle';

import { CardPositionContext, ContentInfoContext } from '../../../../app/contexts/TelemetryContexts';
import { IContentInfo } from '../../../models/IContentInfo';

export interface IFavoriteCellOptions {
  onAddFavorite: (row: DataGrid.Row) => void;
  onRemoveFavorite: (row: DataGrid.Row) => void;
  favoriteCellTestIdFn: (row: DataGrid.Row) => string;
  isAccessDenied: (row: DataGrid.Row) => boolean;
  isFavoritable?: (row: DataGrid.Row) => boolean;
}

export function FavoriteCell(options: IFavoriteCellOptions): React.StatelessComponent<BodyCell.Props> {
  return React.createFactory(class extends React.Component<BodyCell.Props, any> {
    displayName: 'FavoriteCell';

    private boundAddFavorite = () => options.onAddFavorite(this.props.row);
    private boundRemoveFavorite = () => options.onRemoveFavorite(this.props.row);

    public render(): JSX.Element {
      if (options.isAccessDenied(this.props.row)) {
        return null;
      }

      if (_.isFunction(options.isFavoritable) && options.isFavoritable(this.props.row) === false) {
        return <span className="tb-favorite-button-cell" data-tb-test-id="tb-favorite-unavailable"/>;
      }

      let index = this.props.row.data.rowIndex;

      return (
          <ContentInfoContext.Provider value={this.props.row.data as IContentInfo}>
            <CardPositionContext.Provider value={index + 1}>
            <span className="tb-favorite-button-cell"
                  data-tb-test-id={options.favoriteCellTestIdFn(this.props.row)}>
              <FavoriteToggle isFavorite={this.props.row.data.favorite}
                              onAddFavorite={this.boundAddFavorite}
                              onRemoveFavorite={this.boundRemoveFavorite}
                              isTabbable={false}/>
            </span>
            </CardPositionContext.Provider>
          </ContentInfoContext.Provider>
      );
    }
  });
}
